const dataTableFilters = [
  'issuesColumnFilters',
  'topIssuesColumnFilters',
  'orgColumnFilters',
  'issuesDetailColumnFilters',
  'brokenLinksColumnFilters',
  'userPdfsColumnFilters',
  'foundPdfsColumnFilters',
  'pagesColumnFilters',
  'pageDetailColumnFilters',
  'spellCheckSitesColumnFilters',
  'lightHouseColumnFilters',
  'assistColumnFilters',
  'auditColumnFilters',
];

const dataTableSortings = [
  'issuesColumnSorting',
  'topIssuesColumnSorting',
  'orgColumnSorting',
  'issuesDetailColumnSorting',
  'brokenLinksColumnSorting',
  'userPdfsColumnSorting',
  'foundPdfsColumnSorting',
  'pagesColumnSorting',
  'pageDetailColumnSorting',
  'spellCheckSitesColumnSorting',
  'lightHouseColumnSorting',
  'assistColumnSorting',
  'auditColumnSorting',
];

const exceptions = [
  'logout',
  'eyeAbleVariables',
  'cookieBannerAccepted',
  'versionOfLastNotificationSeen',
  'notificationLastViewDate',
  'defaultMyGoalsBoardFilters',
  'i18nextLng',
  'userToursSeen',
  ...dataTableFilters,
  ...dataTableSortings,
];

function clearStorageWithExceptions() {
  for (let key in localStorage) {
    if (!exceptions.includes(key)) {
      localStorage.removeItem(key);
    }
  }

  sessionStorage.clear();
}

export default clearStorageWithExceptions;
